// Skeleton placeholders for list-page loading states. Replaces the
// plain "Loading…" text with a stack of card-shaped blocks so the
// reader's eye anchors to the same vertical rhythm whether the data
// is in transit or already rendered.
//
// Static blocks — no shimmer animation. Keep it calm; the brand glow
// + card stagger are doing the entertaining elsewhere on the page.

interface Props {
  count?: number
  height?: number
}

export function PortalSkeletonList({ count = 3, height = 80 }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} aria-busy="true" aria-live="polite">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} role="presentation"
          style={{
            height, borderRadius: 12,
            background: 'var(--surface)',
            border: '1px solid var(--border-subtle)',
            // The subtle inner band hints at "content goes here" without
            // committing to a specific row anatomy.
            backgroundImage: 'linear-gradient(180deg, var(--surface) 0%, var(--hover-bg) 100%)',
          }} />
      ))}
    </div>
  )
}
